<template>
	<div class="d-flex flex-column p-5 widget-error text-center">
		<img :src="getImage(settings.image)" class="empty-image" :alt="settings.text" />
		<h5 class="mt-2">{{ settings.text }}</h5>
	</div>
</template>

<script>
	import _ from 'lodash'
	export default {
		props: {
			options: { type: Object }
		},
		data() {
			return {
				settings: {
					text: this.$t('home.widgets.m.render-error'),
					image: 'server-error'
				}
			}
		},
		created() {
			this.settings = _.merge(this.settings, this.options)
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					if (val) {
						this.settings = _.merge(this.settings, val)
					}
				}
			}
		},
		methods: {
			getImage(name) {
				return new URL(`/src/assets/${name}.svg`, import.meta.url).href
			}
		}
	}
</script>

<style>
	.widget-error .empty-image {
		max-height: 150px;
	}
</style>